<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M10.659,19.499c-0.61,0-1.188-0.264-1.585-0.725l-3.28-3.676H4.123C3.8,15.51,3.315,15.751,2.789,15.751
		c-0.023,0-0.046,0-0.07-0.001l-1.97,0C0.336,15.75,0,15.414,0,15s0.336-0.75,0.75-0.75c0,0,2.001,0,2.001,0
		c0.095,0,0.167-0.034,0.209-0.091c0.01-0.039,0.024-0.077,0.04-0.115L3,7.666c-0.004-0.08-0.106-0.167-0.218-0.167L0.75,7.5
		C0.336,7.5,0,7.164,0,6.75S0.336,6,0.75,6h2c0.007-0.001,0.03-0.001,0.052-0.001c0.802,0,1.497,0.589,1.662,1.36l3.458-1.383
		C8.259,5.84,8.615,5.771,8.979,5.771c0.613,0,1.197,0.192,1.691,0.555l0.013,0.01l2.411-1.213c0.428-0.216,0.91-0.33,1.394-0.33
		c0.365,0,0.722,0.063,1.062,0.188l4.376,1.601c0.32-0.366,0.787-0.584,1.278-0.584c0.026,0,0.053,0.001,0.079,0.002L23.25,6
		C23.664,6,24,6.336,24,6.75S23.664,7.5,23.25,7.5l-2.027-0.001c-0.12,0-0.219,0.089-0.224,0.202L21,14.083
		c0.004,0.081,0.098,0.168,0.199,0.168c0.008,0,0.028-0.001,0.035-0.001l2.015,0c0.414,0,0.75,0.336,0.75,0.75
		s-0.336,0.75-0.75,0.75h-2c-0.008,0.001-0.03,0.001-0.053,0.001c-0.486,0-0.942-0.213-1.264-0.579l-4.663,0.891
		c-0.048,0.009-0.095,0.013-0.141,0.013c-0.019,0-0.037-0.001-0.052-0.003c-0.016,0.049-0.034,0.098-0.053,0.146
		c-0.368,0.919-1.245,1.513-2.236,1.513c-0.021,0-0.042,0-0.063-0.001c-0.076,0.486-0.322,0.934-0.7,1.26
		C11.645,19.318,11.16,19.499,10.659,19.499z M6.13,13.598c0.213,0,0.417,0.091,0.559,0.25l3.512,3.936
		c0.119,0.138,0.285,0.214,0.459,0.214c0.141,0,0.278-0.051,0.385-0.143c0.13-0.113,0.205-0.276,0.205-0.448v-0.304l-0.758-0.758
		c-0.292-0.292-0.292-0.768,0-1.061c0.142-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22l0.869,0.869l0.032,0.013
		c0.108,0.043,0.22,0.065,0.335,0.065c0.374,0,0.704-0.224,0.843-0.57c0.009-0.021,0.016-0.044,0.023-0.067l-1.206-1.206
		c-0.142-0.142-0.22-0.33-0.22-0.53s0.078-0.389,0.22-0.53s0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22l1.248,1.248h0.178
		c0.396,0,0.717-0.323,0.717-0.719c0-0.154-0.051-0.307-0.143-0.429l-2.805-3.594l-1.52,0.502c-0.193,0.064-0.394,0.096-0.595,0.096
		c-0.739,0-1.416-0.434-1.726-1.105C8.537,8.629,8.668,7.834,9.14,7.281c-0.052-0.006-0.105-0.01-0.158-0.01
		c-0.174,0.001-0.346,0.035-0.5,0.097L4.5,8.96l0,4.638H6.13z M16.7,12.517c0.293,0.39,0.452,0.864,0.452,1.34
		c0,0.109-0.008,0.217-0.024,0.324l2.372-0.453l0-5.703L15.034,6.39c-0.175-0.064-0.359-0.097-0.547-0.097
		c-0.249,0-0.498,0.059-0.718,0.17l-3.36,1.69c-0.199,0.101-0.281,0.339-0.186,0.543c0.066,0.144,0.209,0.236,0.365,0.236
		c0.042,0,0.084-0.007,0.125-0.02l3.467-1.146c0.076-0.025,0.156-0.038,0.236-0.038c0.324,0,0.61,0.207,0.712,0.515
		c0.063,0.19,0.048,0.393-0.042,0.573c-0.09,0.179-0.244,0.312-0.435,0.375l-0.435,0.144L16.7,12.517z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'business-deal-handshake',
    },
    name: {
      type: String,
      required: false,
      default: 'BusinessDealHandshake',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>